<template>
  <v-app>
    <!-- APP BAR -->
    <v-app-bar
      app
      flat
      class="app-bar-with-bg white"
      :height="$vuetify.breakpoint.xs ? 45 : 65"
    >
    <v-row no-gutters class=" d-flex justify-center">
    <v-col cols="12" md="10">
      <v-container  class="d-flex align-center justify-space-between white py-0  " style="max-width : 1140px">
        <!-- Lewa strona – nazwa / logo tekstowe -->
<!--         <div class="d-flex justify-start pink"> -->

        <v-img
          class="shrink mr-2 ml-1 "
          :class="$vuetify.breakpoint.mdAndDown ? 'ml-n4 mr-n10' : '' "
          :style="$vuetify.breakpoint.xs ? 'height : 43px ; width : 280px' : ''"
          style="height : 56px; max-width : 370px; width : 100% ;   position : relative"
          src="images/logo1.jpg"
          transition="scale-transition"
          color="primary"
          />


<!--         </div> -->

        <!-- Prawa strona – TABS -->
<!--         {{tab}} -->
<!-- <v-spacer/> -->
    <div v-if="!$vuetify.breakpoint.smAndDown" class="">
<!--           v-if="!this.$vuetify.breakpoint.smAndDown" -->
        <v-tabs
          :value="tab"
          background-color="transparent"
          grow
          slider-size="3"
          align-with-title
          class="app-tabs mb-n1"
        >
          <v-tab style="max-width : 100px" @click="$refs.contentRef.scrollToSection(0), tab = 0">Profil</v-tab>
          <v-tab style="max-width : 100px" @click="$refs.contentRef.scrollToSection(1), tab = 1">Projekte</v-tab>
          <v-tab style="max-width : 100px" @click="$refs.contentRef.scrollToSection(2), tab = 2 ">Kontakt</v-tab>
        </v-tabs>
    </div>
    <div v-else>
      <v-menu
            v-model="smallMenu"
            offset-y
            nudge-top="-7"
            transition="scroll-y-transition"
            bottom

            >
        <template #activator="{ on} ">
          <v-btn v-on="on" large icon @click="dialog = false" class=" align-self-end  mt-1   close-btn" :class="$vuetify.breakpoint.xs ? 'mr-n7' : 'mr-n2' " >
            <v-icon md>mdi-menu</v-icon>
          </v-btn>
            </template>
            <div class="transparent ">
                    <v-card class="  " style=" border-radius : 10px ">
                                        <v-btn

                                            class="tab-mobile title mx-10 mt-3 "
                                            text
                                            @click="$refs.contentRef.scrollToSection(0), tab = 0"
                                            :color="tab == 0 ? 'primary' : ''"
                                        >
                                        Profil
                                        </v-btn>
                                     <div class="d-flex justify-center  pa-5">
                                        <v-btn

                                            class="tab-mobile  title"
                                            text
                                            @click="$refs.contentRef.scrollToSection(1), tab = 1"
                                            :color="tab == 1 ? 'primary' : ''"
                                        >
                                        Projekte

                                        </v-btn>
                                         </div>

                                         <div class="d-flex justify-center   ">
                                        <v-btn

                                            class="tab-mobile title mb-4"
                                            text
                                            @click="$refs.contentRef.scrollToSection(2), tab = 2"
                                            :color="tab == 2 ? 'primary' : ''"
                                        >
                                        Kontakt

                                        </v-btn>
                                </div>
            </v-card>
            </div>
        </v-menu>
        </div>
  </v-container>
  </v-col>
  </v-row>
</v-app-bar>


    <v-main>
      <mainPage ref="contentRef" :tab.sync="tab"/>
    </v-main>
  </v-app>
</template>

<script>
// import mainPage from './components/mainpage'

export default {
  name: 'App',

  components: {
    mainPage : () => import('./components/mainpage')
  },

  data: () => ({
    tab : 0,
    smallMenu : false,
  }),
};
</script>
<style>
.v-application, .v-application * {
  font-family: "Calibri", sans-serif !important;
}

@font-face {
  font-family: 'Calibri';
  src: url('/fonts/calibri.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

/* MAX 1360px, wyśrodkowane */
.app-shell {
  max-width: 1360px;
}

/* Obrazek jako tło paska nawigacji – na całą szerokość app-bara */
/* .app-bar-with-bg { */
/*   background-image: url('images/logo.jpg'); */
/*   background-size: cover; */
/*   background-position: center; */
/*   background-repeat: no-repeat; */
/*   color: #fff; */
/* } */

/* Tytuł w pasku */
.app-title {
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

/* Tabs – delikatne, portfolio style */
.app-tabs .v-tab {
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.08em;
}

.app-tabs .v-tab--active {
  font-weight: 600;
}
</style>
